import React, { ReactNode } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { BreadCrumbsAndTitle } from './BreadCrumbsAndTitle';
import { AlertsInformativos } from './AlertsInformativos';
import { mtDividerUpTable } from 'commons';

interface PageLayoutProps {
  title: string;
  mainModule: string;
  icon?: string;
  infoAlert?: string;
  actionButtons?: ReactNode;
  children: ReactNode;
  parent?: string;
  action?: string;
}

export const PageLayout = ({
  title,
  mainModule,
  icon,
  infoAlert,
  actionButtons,
  children,
  parent = '',
  action = '',
}: PageLayoutProps) => {
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, margin: '0 auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Box>
          <BreadCrumbsAndTitle
            title={title}
            mainModule={mainModule}
            parent={parent}
            action={action}
            icon={icon}
          />
        </Box>

        {actionButtons && (
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 2 }}>{actionButtons}</Box>
        )}
      </Box>

      {infoAlert && (
        <Typography variant="body2" color="text.secondary" sx={{ width: '100%', mb: 2 }}>
          <AlertsInformativos type={'info'} title={'info'} content={infoAlert} />
        </Typography>
      )}

      <Divider sx={{ marginBottom: mtDividerUpTable }} />

      {children}
    </Box>
  );
};
